import { FeatureEntitlements } from '@/common/types/organisation';

export const FREE_ENTITLEMENTS: FeatureEntitlements = {
  'lesson-planner': true,
  'word-mat': true,
};

export const FAMILY_ENTITLEMENTS: FeatureEntitlements = {
  game: true,
  assessments: true,
  'activity-feed': true,
};

export const PRO_ENTITLEMENTS: FeatureEntitlements = {
  insights: true,
  'learner-notes': true,
  'custom-levels': true,
};

export const TRIAL_ENTITLEMENTS: FeatureEntitlements = {
  ...FREE_ENTITLEMENTS,
  ...FAMILY_ENTITLEMENTS,
  ...PRO_ENTITLEMENTS,
};

export function getEntitlements(plan: string): FeatureEntitlements {
  const features = Object.keys(FREE_ENTITLEMENTS);
  if (plan !== 'free')
    // family plan
    features.push(...Object.keys(FAMILY_ENTITLEMENTS));
  if (plan !== 'free' && plan !== 'family')
    // pro plan
    features.push(...Object.keys(PRO_ENTITLEMENTS));
  return Object.fromEntries(features.map((f) => [f, true]));
}
